<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19NdZQu/tc-custom/9781466865952.jpg?1737330350899" alt="This image is the cover for the book I Will Survive"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Will Survive
      </h1>
      <p class="bookDescription body article font2">
        <b>Gloria Gaynor, the “Queen of Disco,” tells her story of stardom, despair, and finally, salvation.</b><br/><br/>Her meteoric rise to fame in the mid-1970s was nothing short of phenomenal, and hits poured forth that pushed her to the top of the charts, including “Honey Bee,” “I Got You Under My Skin,” “Never Can Say Goodbye,” and the song that has immortalized her, “I Will Survive,” which became a #1 international hit. With that song, Gloria Gaynor heralded the rise of disco, which became synonymous with life in the fast lane—the sweaty bodies at Studio 54, the lines of cocaine, the indescribable feeling that you could always be at the top of your game and never come down.<br/><br/>But down she came after her early stardom, and problems followed in its wake including the death of her mother, whose love had anchored the young singer, and constant battles with weight, drugs, and alcohol. While her fans always imagined her to be rich, her personal finances collapsed due to poor management, and while many envied her, she felt completely empty inside. In the early 1980s, sustained by her marriage to music publisher Linwood Simon, Gloria took three years off and reflected upon her life. She visited churches and revisited her mother’s old Bible. Discovering the world of gospel, she made a commitment to Christ. In this faith-filled autobiography, she tells the story of how she survived—and thrived.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gloria Gaynor
      </h2>
      
      <p class="authorDescription body article"><P>Gloria Gaynor is America's "Queen of Disco," and the author of this autobiography, <I>I Will Survive. </I></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a8f2c58